import { Logger as ExternalLogger } from '@coxy/logger'

const MAX_PULL_SIZE = 300
const pull: unknown[] = []

export const CoreLogger = new ExternalLogger({ name: 'core', isEnabled: true })
export const AppLogger = new ExternalLogger({ name: 'app', isEnabled: true })

export const getLoggerPull = () => {
  return pull
}

const parseLogs = (...args: unknown[]) => {
  return args.map((el) => {
    if (el instanceof Error) {
      return [el.message]
    }
    return el
  })
}

// eslint-disable-next-line @eslint-react/rules-of-hooks
CoreLogger.use((type, ...args) => {
  if (pull.length >= MAX_PULL_SIZE) pull.shift()
  pull.push({
    time: Date.now(),
    type,
    log: parseLogs(...args),
  })
})

// eslint-disable-next-line @eslint-react/rules-of-hooks
AppLogger.use((type, ...args) => {
  if (pull.length >= MAX_PULL_SIZE) pull.shift()
  pull.push({
    time: Date.now(),
    type,
    log: parseLogs(...args),
  })
})
